import { Grid, Typography } from '@material-ui/core';
import { Error } from '@material-ui/icons';
import laqusImf from 'assets/laqus-imf-digital-1x.png';
import { Button, MdSpace, SmSpace, TextButton, TextField } from 'm2m.components';
import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { RootState } from 'store';

const mapStateToProps = (state: RootState) => ({
  usuarioApi: state.usuarioApi,
});

const RequestNovaSenha: React.FC<{ onGetBack(): void } & ReturnType<typeof mapStateToProps>> = (props) => {
  const {
    usuarioApi: { postNovaSenhaRequest },
  } = props;
  const [email, setEmail] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<string>('');

  const dispatch = useDispatch();

  const submit = async (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault();
    try {
      const result = await postNovaSenhaRequest(dispatch, email);
      if (result) handleGetBack();
    } catch (error: any) {
      setErrorMsg('Não foi possível realizar a operação, entre em contato com o administrador!');
    }
  };

  const handleGetBack = () => {
    setEmail('');
    setErrorMsg('');
    props.onGetBack();
  };

  const isEmailValid =
    email && email.match(/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i);

  return (
    <Grid container justify="center">
      <Grid item>
        <img src={laqusImf} alt="Logo Laqus IMF digital" />
      </Grid>
      <Grid item sm={12}>
        <MdSpace />
        <Typography align="center" variant="h2">
          {`Esqueceu a senha?`}
        </Typography>
        <MdSpace />
        <Typography align="center" variant="body2">
          {`Enviaremos um email com instruções de como redefinir sua senha. Nos informe seu e-mail cadastrado abaixo.`}
        </Typography>
        <MdSpace />
        {email && !isEmailValid && (
          <>
            <div style={{ display: 'flex' }}>
              <Error style={{ marginRight: 10 }} color="error" />
              <Typography variant="body2" color="error">{`Digite um e-mail válido.`}</Typography>
            </div>
            <SmSpace />
          </>
        )}
        {errorMsg && (
          <>
            <div style={{ display: 'flex' }}>
              <Error style={{ marginRight: 10 }} color="error" />
              <Typography variant="body2" color="error">
                {errorMsg}
              </Typography>
            </div>
            <SmSpace />
          </>
        )}
        <form onSubmit={submit}>
          <TextField label="E-mail" required value={email} onChange={(value) => setEmail(value)} />
          <MdSpace />
          <Grid container alignItems="center" justify="space-between">
            <TextButton
              onClick={handleGetBack}
              style={{ padding: '0 0 5px 0', minWidth: 44, borderBottom: '1px solid #00E08E', borderRadius: 0 }}
            >
              {`Voltar`}
            </TextButton>
            <Button type="submit" variant="contained" color="primary" style={{ margin: '0', padding: '16px 60px' }}>
              {'Enviar E-mail'}
            </Button>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};

export default connect(mapStateToProps)(RequestNovaSenha);
